import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// We no longer register a service worker (see vite.config.ts for why). Blow
// away any SW left over from a previous build/deploy — in dev that stopped a
// stale SW from intercepting /api requests with a broken bundle; in
// production it cleans up the old vite-plugin-pwa-registered SW for anyone
// who already has it installed.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .then((regs) => {
      if (typeof console !== 'undefined') {
        console.info(`[archer] unregistered ${regs.length} stale service worker(s)`);
      }
    })
    .catch(() => undefined);
  if ('caches' in window) {
    caches.keys().then((keys) => keys.filter((k) => k.startsWith('workbox-')).forEach((k) => caches.delete(k)));
  }
}

const rootEl = document.getElementById('root');
if (rootEl) {
  // No <React.StrictMode> in dev: it double-invokes effects which triggers
  // double loads of the project, and was the root cause of the long-standing
  // "shapes get replicated" issue interacting with our HMR + Konva pipeline.
  // In production we keep the same root render (StrictMode is a no-op there).
  ReactDOM.createRoot(rootEl).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
}
